var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.showSessionQR ? _c('div', [_c('v-btn', {
    staticClass: "text-center qr-button",
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.loadQRCode
    }
  }, [_c('span', {
    staticClass: "qr-button-text d-none d-md-inline mr-2"
  }, [_vm._v("Reconnect phone")]), _c('v-icon', [_vm._v("mdi-qrcode")])], 1), _c('v-dialog', {
    attrs: {
      "content-class": "app-dialog",
      "max-width": "420",
      "width": "auto",
      "retain-focus": false
    },
    on: {
      "click:outside": _vm.closeDialog
    },
    model: {
      value: _vm.dialog,
      callback: function ($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    ref: "qrCard"
  }, [_c('v-card-text', {
    staticClass: "qr-code-content"
  }, [_vm.loading ? _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "grey",
      "size": "32",
      "width": "5"
    }
  }) : _c('img', {
    staticClass: "qr-code-image",
    attrs: {
      "src": _vm.session.qrcode
    }
  })], 1), _c('v-card-actions', {
    staticClass: "qr-dialog-actions"
  }, [_vm.showOpenInAppButton ? _c('p', {
    staticClass: "qr-dialog-note mb-2"
  }, [_vm._v(" Monocular access via QR code or Open in app deeplink requires OpenCap App Store version 2.0+. ")]) : _vm._e(), _vm.showOpenInAppButton ? _c('v-btn', {
    staticClass: "qr-dialog-btn",
    attrs: {
      "color": "grey darken-4",
      "dark": "",
      "block": ""
    },
    on: {
      "click": _vm.openInApp
    }
  }, [_vm._v(" Open in app ")]) : _vm._e(), _c('v-btn', {
    staticClass: "qr-dialog-btn",
    attrs: {
      "text": "",
      "block": ""
    },
    on: {
      "click": function ($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }